export const fontColorPlugin = {
  isLeaf: true,
};
